import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createExchangeOrder, getIsAutoCreateExchangeOrder } from '@entities/exchange';
export function useAutoCreateExchangeOrder() {
    const dispatch = useDispatch();
    const isAutoCreateFreeExchangeOrder = useSelector(getIsAutoCreateExchangeOrder);
    useEffect(() => {
        if (!isAutoCreateFreeExchangeOrder) {
            return;
        }
        dispatch(createExchangeOrder({ isAutoCreate: true }));
    }, [dispatch, isAutoCreateFreeExchangeOrder]);
}
